<template>
  <main>
    <contact-us-blurb />
    <div class="container-fluid bg-white pt-3">
      <div class="container">
        <food-navbar current="food-groups" />
      </div>
    </div>
    <div class="container-fluid bg-white py-5">
      <div class="container">
        <div class="page-sidebar-layout">
          <div class="side sidebar">
            <div class="sidebar-box">
              <div class="box-section box-title">
                Food Group Categories
              </div>
              <div class="box-section">
                <!-- <div class="accordion-list">
									<div class="accordion-item" v-for="group in food_category_groups" v-bind:class="{on: group.is_open}">
										<div class="accordion-title" v-on:click="group.is_open = !group.is_open;">
											<div class="icon"><i class="fas fa-plus-circle"></i></div>
											<div class="title">{{ group.name }}</div>
										</div>
										<div class="accordion-content">
											<a class="list-item-link" v-for="item in group.items" v-on:click="food_category= group.name+' - '+item.name;category_sid=item.sid; food_search=''; itemData=null; getItems(item.sid,food_search);">{{ item.name }}</a>
										</div>
									</div>
								</div> -->
                <div class="accordion-list">
                  <template v-for="group in food_category_groups">
                    <div
                      v-for="item in group.items"
                      class="accordion-item"
                      @click="categoryClicked(item)"
                    >
                      <div class="accordion-title">
                        <div class="icon">
                          <i class="fas fa-plus-circle" />
                        </div>
                        <div class="title">
                          {{ item.name }}
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div
            ref="search-result-container"
            class="side main"
          >
            <div class="page-title-box">
              {{ pageTitle }}
            </div>

            <disclaimer-food-search :show-disclaimer="showDisclaimer" />

            <div class="page-subheader-box">
              <div class="row">
                <div class="col-md form-group">
                  <select
                    v-model="sortfilter"
                    class="form-control"
                  >
                    <option value="">
                      Sort By
                    </option>
                    <option value="name-asc">
                      A - Z
                    </option>
                    <option value="name-desc">
                      Z - A
                    </option>
                    <option value="factor-asc">
                      Factor: Low - High
                    </option>
                    <option value="factor-desc">
                      Factor: High - Low
                    </option>
                  </select>
                </div>
                <div class="col-md form-group">
                  <select
                    v-model="colorfilter"
                    class="form-control"
                  >
                    <option value="">
                      All Colors
                    </option>
                    <option value="g">
                      Green
                    </option>
                    <option value="y">
                      Yellow
                    </option>
                    <option value="r">
                      Red
                    </option>
                  </select>
                </div>
                <div class="col-md form-group">
                  <input
                    v-model="food_search"
                    type="text"
                    class="fff-ui form-control"
                    placeholder="Search..."
                    @keyup="getItems(category_sid);"
                  >
                </div>
              </div>
            </div>

            <!-- Search Results -->
            <loading-spinner
              v-if="isSearching"
              :show-spinner="isSearching"
            />
            <div
              v-else
              class="container py-2 px-0 foodgroupitems"
            >
              <pagination
                :params="paginationParams"
                @go-to-page="load_items"
              />
              <food-search-list :items="itemData" />
              <pagination
                :params="paginationParams"
                @go-to-page="load_items"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import foodcleaner from '../components/FoodSearchShared'
export default {
  name: 'FoodGroups',
  data() {
    return {
      food_search: '',
      food_category: 'Select a Category',
      category_sid: '',
      food_category_groups: [],
      itemData:null,
      paginationParams:{
        current_page:1,
        total_pages:1
      },
      sortfilter:'',
      colorfilter:'',
      showDisclaimer: true,
      isSearching: false,
    };
  },
  computed: {
    pageTitle() {
      return 'Foods' + (this.food_category === 'Select a Category' ? '' : ' : ' + this.food_category);
    },
  },
  watch: {
    'sortfilter': function () {
      this.getItems(this.category_sid);
    },
    'colorfilter': function () {
      this.getItems(this.category_sid);
    },
  },
  created() {
    // Detect 'meal-log-entry-added' event at the root level
    this.$root.$el.addEventListener('meal-log-entry-added', this.resetSearchBox);
  },
  beforeDestroy() {
    // Clean up event listeners otherwise the same listener will be added to the root
    // Can be detected on Chromium browser using `getEventListeners(document.getElementById('app'))`
    this.$root.$el.removeEventListener('meal-log-entry-added', this.resetSearchBox);
  },
  async mounted(){
    let foodgroups = await this.$http('/api/foodcategories/all',{
      method:"get",
    }).then(response => response.json())
      .then(async function(json) {
        return json.data;
      });
    foodgroups = foodcleaner.cleanfoodgroupcategories(foodgroups);
    this.food_category_groups =foodgroups;
  },
  methods: {
    /**
		 * Clear search box and perform blank search
		 */
    resetSearchBox() {
      this.food_search = '';
      this.getItems(this.category_sid);
    },
    returnData(itemData){
      itemData = foodcleaner.cleanfooditems(itemData);
      console.log(itemData);
      this.itemData = itemData;
    },
    categoryClicked(item) {
      this.food_category = item.name;
      this.category_sid = item.sid;
      this.food_search = '';
      this.itemData = null;
      this.getItems(item.sid);
    },
    async getItems(category_sid){
      // console.log('[FoodGroups] getItems(category_sid):', category_sid);	// Debug only

      // Suggestion: Should 'debounce' to avoid firing the event on every keystroke
      // Hide disclaimer
      this.showDisclaimer = false;
      // Show spinner
      this.isSearching = true;

      this.category_sid = category_sid;
      let term  = this.food_search;
      if(term!='' && term.length<3){}
      else{
        let sort_column='';
        let sort_order='';
        let filter_color='';
        if(this.sortfilter!=''){
          sort_column = this.sortfilter.split("-")[0];
          sort_order = this.sortfilter.split("-")[1];
        }
        if(this.colorfilter!=''){
          filter_color = this.colorfilter;
        }
        let foodItemsrequest = await foodcleaner.search(term, 0, {
          'category_sid':category_sid,
          'sort_column':sort_column,
          'sort_order':sort_order,
          'filter_color':filter_color
        });
        let foodItems = foodcleaner.cleanfooditems(foodItemsrequest.data);
        this.itemData =foodItems;
        this.paginationParams = {
          current_page: foodItemsrequest.meta.current_page,
          last_page: foodItemsrequest.meta.last_page,
        };
      }

      this.isSearching = false;

      this.$nextTick(() => {
        this.$refs["search-result-container"].scrollIntoView({
          behavior: 'smooth',
        });
      });
    },
    async load_items(page){
      // Show spinner
      this.isSearching = true;

      let category_sid = this.category_sid;
      let term = this.food_search;
      let sort_column='';
      let sort_order='';
      let filter_color='';
      if(this.sortfilter!=''){
        sort_column = this.sortfilter.split("-")[0];
        sort_order = this.sortfilter.split("-")[1];
      }
      if(this.colorfilter!=''){
        filter_color = this.colorfilter;
      }
      let foodItemsrequest = await foodcleaner.search(term, page, {
        'category_sid':category_sid,
        'sort_column':sort_column,
        'sort_order':sort_order,
        'filter_color':filter_color
      });
      let foodItems = foodcleaner.cleanfooditems(foodItemsrequest.data);
      this.itemData =foodItems;
      this.paginationParams = {
        current_page: foodItemsrequest.meta.current_page,
        last_page: foodItemsrequest.meta.last_page,
      };

      this.isSearching = false;
    }
  }
};
</script>

<style lang="scss">
	.foodgroupitems .food-item .graphic{padding:10px !important;}
	.foodgroupitems .food-factor-circle{border-width:4px;}
	.foodgroupitems .food-item .graphic .food-factor-circle{font-size:2.5rem !important;}
	.foodgroupitems .food-item .graphic.has-image .food-factor-circle{font-size:1em !important;}
</style>
